/**
 * Check if button attributes have any values
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { hasAnyResponsiveValues } from '../../../common';
import type { ButtonAttributes, ButtonValues } from '../../types';

/**
 * Check if button attributes have any values
 */
export const hasButtonValues = ( attributes: ButtonAttributes ): boolean => {
	return hasAnyResponsiveValues( attributes, ( values: ButtonValues ) => {
		return Object.values( values ).some( ( value ) => {
			if ( typeof value === 'string' ) {
				return value !== '';
			}
			if ( typeof value === 'object' && value !== null ) {
				return Object.values( value ).some( ( v ) => v !== '' );
			}
			return false;
		} );
	} );
};
